export default {
  goals: [],
  apiCallsInProgress: 0
};
